import React from 'react';
import api from '../../../api/apiClient';
import EventCalendarView from '../../../common/components/calendar/EventCalendarView';
import { EVENT_TYPE_META } from '../../../common/utils/calendarHelpers';

const USER_CALENDAR_LEGEND = [
  EVENT_TYPE_META.course,
  EVENT_TYPE_META.assessment
];

const MyEventCalendarPage = () => (
  <EventCalendarView
    title="My Event Calendar"
    description="Scheduled courses, assessments, and live meetings assigned to you."
    emptyMessage="Your scheduled courses, assessments, and meetings will appear here."
    legendItems={USER_CALENDAR_LEGEND}
    vltPath="/user/vlt"
    assessmentMode="user"
    loadEvents={async ({ start, end }) => {
      const response = await api.calendar.getUserEvents({ start, end });
      return response.data?.data || [];
    }}
  />
);

export default MyEventCalendarPage;
